import React, { useEffect } from 'react'
import {
  AutocompleteStyle,
  TextFieldModalStyle,
  TradeBodyContainer,
  TradeBodySubContainer,
  UnVisibleSubmitButton
} from '../../Trade.style'
import PropTypes from 'prop-types'
import { Label } from '../../../../components/styled/global.style'
import SpotTrade from '../SpotTrade/SpotTrade'
import VanillaTrade from '../VanillaTrade/VanillaTrade'
import SwapTrade from '../SwapTrade/SwapTrade'
import ModalBottom from '../../../../components/ModalApp/components/ModalBottom/ModalBottom'
import NdfTrade from '../NdfTrade/NdfTrade'
import { Box } from '@mui/material'
import Loader from '../../../../components/Loader/Loader'
import { ACTION, routes } from '../../../../utils/constants'
import { useState } from 'react'
import useTradeSetting from '../../hook/trade.setting'
import useAxios from '../../../../hooks/useAxios'
import TradeForm from '../../classes/TradeForm'
import { useRef } from 'react'
import { checkSomeLoader } from '../../../../helper'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import { handelNotifications } from '../../../../redux/slices/Notification/notificationSlice'
import { webSocketWorkerEvent } from '../../../../services'
import { useDispatch } from 'react-redux'

const Body = ({ data }) => {
  const dispatch = useDispatch()
  const { action, method, disabled: disabledSomeFields } = data
  let loaderFirstTime = useRef(true).current
  const [errors, setErrors] = useState({})

  useEffect(() => {
    const handelMessage = message => {
      if (message.data.type === 'create_trade' && message.data.status === 'ok') {
        dispatch(
          handelNotifications({
            id: Date.now(),
            type: 'success',
            message: 'Trade Made Successfully'
          })
        )
      }
      if (message.data.type === 'update_trade' && message.data.status === 'ok') {
        dispatch(
          handelNotifications({
            id: Date.now(),
            type: 'success',
            message: 'Trade Update Successfully'
          })
        )
        // window.close()
      }
    }

    webSocketWorkerEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerEvent.removeEventListener('message', handelMessage)
  }, [dispatch])

  const currencyInitial = { id: 0, name: '', code3: '', is_ndf: '' }
  const tradeTypeInitial = { id: 0, name: '', deal_type_group: '' }
  const traderInitial = { id: 0, name: '' }

  const request1 = {
    endPoint: routes.currency
  }
  const request2 = {
    endPoint: routes.side
  }

  const request3 = {
    endPoint: routes.counterParty,
    params: {
      direction: data.data.trade_type.includes('Client') ? 'Client' : 'Market Maker',
      is_active: 1
    }
  }
  const request4 = {
    endPoint: routes.tradeType,
    params: {
      type: data.data.trade_type.includes('Client') ? 'Client' : 'Market'
    }
  }
  const request5 = {
    endPoint: routes.cut
  }

  const request6 = {
    endPoint: routes.fixingSource
  }

  const request7 = {
    endPoint: routes.trader,
    params: {
      type: data.data.trade_type.includes('Client') ? 'Client' : 'Market'
    }
  }
  const request8 = {
    endPoint: routes.tradeTypeGroup
  }

  const request9 = {
    endPoint: routes.currencyNormalize
  }

  const request10 = {
    endPoint: routes.tradingAccountTradersNormalize
  }

  const request11 = {
    endPoint: routes.tradingAccountPrimeBrokerNormalize
  }

  const request12 = {
    endPoint: routes.barrierDirection
  }

  const { response: currencyData, loading: currencyLoader } = useAxios(request1)
  const { response: sides, loading: sidesLoader } = useAxios(request2)
  const { response: counterParty, loading: counterPartyLoader } = useAxios(request3)
  const { response: tradeTypes, loading: tradeTypesLoader } = useAxios(request4)
  const { response: cut, loading: cutLoader } = useAxios(request5)
  const { response: fixingSource, loading: fixingSourceLoader } = useAxios(request6)
  const { response: traders, loading: tradersLoader } = useAxios(request7)
  const { response: tradeTypesGroup, loading: tradeTypeGroupLoader } = useAxios(request8)
  const { response: currencyNormalize, loading: currencyNormalizeLoader } = useAxios(request9)
  const {
    response: tradingAccountTradersNormalize,
    loading: tradingAccountTradersNormalizeLoader
  } = useAxios(request10)
  const {
    response: tradingAccountPrimeBrokerNormalize,
    loading: tradingAccountPrimeBrokerNormalizeLoader
  } = useAxios(request11)
  const { response: barrierDirectionData, loading: barrierDirectionLoader } = useAxios(request12)

  const loaderList = [
    currencyLoader,
    sidesLoader,
    counterPartyLoader,
    tradeTypesLoader,
    cutLoader,
    fixingSourceLoader,
    tradersLoader,
    tradeTypeGroupLoader,
    currencyNormalizeLoader,
    tradingAccountTradersNormalizeLoader,
    tradingAccountPrimeBrokerNormalizeLoader,
    barrierDirectionLoader
  ]

  const [form, setForm] = useState(new TradeForm(data.data))

  const {
    exoticTradeBody,
    submitForm,
    disabled,
    handelFormChange,
    handelDateChange,
    disabledField,
    disabledConversionCheckBox,
    handelFocusCurrencyPair,
    handelBlurCurrencyPair,
    getTradeTemplateGridRow,
    checkPrimeBrokerIsRBS,
    swapOption
  } = useTradeSetting({
    form,
    setForm,
    currencyNormalize,
    currencyInitial,
    tradeTypesGroup,
    tradeTypeInitial,
    traderInitial,
    currencyData,
    data,
    action,
    barrierDirectionData,
    tradingAccountPrimeBrokerNormalize,
    errors,
    setErrors
  })

  const handelSubmit = event => {
    event.preventDefault()
    if (!disabled()) {
      submitForm()
    }
  }

  if (checkSomeLoader(loaderList) && loaderFirstTime) {
    loaderFirstTime = false
    return <Loader />
  }

  const exoticTrade = exoticTradeBody()

  return (
    <TradeBodyContainer>
      <TradeBodySubContainer
        component="form"
        onSubmit={handelSubmit}
        container
        style={getTradeTemplateGridRow()}
      >
        <Box width={'100%'}>
          <Label>Trade Type *</Label>
          {Array.isArray(tradeTypes.data) && (
            <AutocompleteStyle
              onChange={(event, element) => {
                event.target.name = 'trade_type'
                element = element ?? tradeTypeInitial
                handelFormChange(event, element)
              }}
              size={'small'}
              value={form.trade_type}
              getOptionLabel={option => option.name}
              options={tradeTypes.data}
              renderInput={params => (
                <TextFieldModalStyle
                  {...params}
                  fullWidth
                  autoFocus
                  placeholder="Select Trade"
                  disabled={disabledSomeFields}
                />
              )}
              disabled={disabledSomeFields}
              ListboxComponent={PaperAutoComplete}
            />
          )}
        </Box>

        {['Spot', 'Forward', ''].includes(form.trade_type.deal_type_group) && (
          <SpotTrade
            tradeType={data.data.trade_type.includes('Client') ? 'Client' : 'Market'}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            disabledConversionCheckBox={disabledConversionCheckBox()}
            handelFormChange={handelFormChange}
            sides={sides}
            insideDeal={data.data.inside_deal}
            counterParty={counterParty}
            form={form}
            errors={errors}
            checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
            handelDateChange={handelDateChange}
            handelBlurCurrencyPair={handelBlurCurrencyPair}
            handelFocusCurrencyPair={handelFocusCurrencyPair}
          />
        )}
        {!['', 'Spot', 'Swap', 'Forward', 'NDF'].includes(form.trade_type.deal_type_group) && (
          <VanillaTrade
            counterParty={counterParty}
            form={form}
            cut={cut}
            sides={sides}
            checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
            disabledField={disabledField()}
            putCall={[{ name: 'PUT' }, { name: 'CALL' }]}
            fixingSource={fixingSource}
            traders={traders}
            handelFormChange={handelFormChange}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            handelDateChange={handelDateChange}
            errors={errors}
            handelBlurCurrencyPair={handelBlurCurrencyPair}
            handelFocusCurrencyPair={handelFocusCurrencyPair}
            tradingAccountTradersNormalize={tradingAccountTradersNormalize}
          >
            {exoticTrade && <React.Fragment>{exoticTrade}</React.Fragment>}
          </VanillaTrade>
        )}

        {['Swap'].includes(form.trade_type.deal_type_group) && (
          <SwapTrade
            form={form}
            sides={sides}
            counterParty={counterParty}
            fixingSource={fixingSource}
            handelFormChange={handelFormChange}
            handelFocusCurrencyPair={handelFocusCurrencyPair}
            handelBlurCurrencyPair={handelBlurCurrencyPair}
            errors={errors}
            checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
            handelDateChange={handelDateChange}
            swapOption={swapOption}
          />
        )}
        {['NDF'].includes(form.trade_type.deal_type_group) && (
          <NdfTrade
            form={form}
            sides={sides}
            fixingSource={fixingSource}
            counterParty={counterParty}
            checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
            handelFormChange={handelFormChange}
            handelFocusCurrencyPair={handelFocusCurrencyPair}
            handelBlurCurrencyPair={handelBlurCurrencyPair}
            errors={errors}
            handelDateChange={handelDateChange}
          />
        )}
        <UnVisibleSubmitButton type="submit" onSubmit={handelSubmit}></UnVisibleSubmitButton>
      </TradeBodySubContainer>

      <Box>
        <ModalBottom
          title={action === ACTION.CREATE ? 'Create Trade' : 'Save Changes'}
          method={method}
          submitForm={submitForm}
          disabled={disabled()}
          justifyContent="space-between"
          padding={{ paddingLeft: '0px', paddingRight: '0px' }}
        />
      </Box>
    </TradeBodyContainer>
  )
}

export default Body

Body.propTypes = {
  data: PropTypes.object
}
